module.exports = __webpack_public_path__ + "img/2-r.61dbea85.png";